<template>
  <!-- <vue-plyr :options="options">
    <video
      controls
      crossorigin
      playsinline
      data-poster="poster.jpg"
      :style="`max-height:${maxHeight};max-width:${maxWidth}`"
      class="img-fluid rounded-lg"
    >
      <source :src="src" />
    </video>
  </vue-plyr> -->

  <div
    class="relative video-container rounded-lg"
    :style="`height:${maxHeight}`"
  >
    <video
      playsinline
      webkit-playsinline
      v-intersect="{
        handler: onIntersect,
        options: {
          threshold: [0.5],
        },
      }"
      :src="src"
      class="img-fluid"
      ref="video"
      @click="toggleVideoPlayer"
      type="video/mp4"
    ></video>

    <v-fab-transition>
      <v-btn
        absolute
        right
        fab
        small
        bottom
        style="bottom: 1.2rem"
        color="transparent"
        @click="toggleMuteBtn"
        v-if="!noPlay"
      >
        <v-icon color="grey">
          {{ !mute ? "mdi-music-note-outline" : "mdi-music-note-off-outline" }}
        </v-icon>
      </v-btn>
    </v-fab-transition>

    <v-fab-transition>
      <v-btn icon @click="toggleVideoPlayer" v-if="!playing" class="play-video">
        <v-icon color="primary" size="40px">mdi-play</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import enableInlineVideo from 'iphone-inline-video';

export default {
  name: "video-layer",
  props: {
    src: { type: String },
    noPlay: { type: Boolean, default: false },
    maxHeight: { type: String, default: "350px" },
    maxWidth: { type: String, default: "100%" },
    width: { type: String, default: "auto" },
  },
  data() {
    return {
      play: false,
      mute: true,
      showMuteBtn: true,
      playing: false,
      playerOptions: {
        muted: true,
        autoplay: true,
        sources: [
          {
            type: "video/mp4",
            src: this.src,
          },
        ],
      },
    };
  },
  computed: {
    options() {
      if (this.noPlay) {
        return { controls: [] };
      }

      return {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
        ],
      };
    },
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      enableInlineVideo(this.$refs.video);
      if (!isIntersecting) {
        this.playing = false;
        this.$refs.video.pause();
      } else {
        if (this.noPlay) return;
        if (!this.playing && this.$refs.video.paused) {
          this.$refs.video.muted = this.mute;
          this.$refs.video.play();
          this.playing = true;
        }
      }
    },
    toggleMuteBtn() {
      if (!this.$refs.video) return;
      this.mute = !this.mute;
      this.$refs.video.muted = !this.$refs.video.muted;
    },
    toggleVideoPlayer() {
      if (this.noPlay) return this.$emit("clicked");

      if (this.$refs.video.paused) {
        this.$refs.video.play();
        this.playing = true;
      } else {
        this.$refs.video.pause();
        this.playing = false;
      }
    },
  },
  mounted() {
    
  },
};
</script>

<style lang="scss" scoped>
.img-fluid {
  height: auto;
  max-width: 100%;
  width: auto;
}

.video-container {
  width: 100%;
  overflow: hidden;
  video {
    width: 100%;
    position: absolute;
    top: 50%;
    right: 0;
    border: 0;
    left: 0;
    transform: translateY(-50%);
  }
}

.play-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
